<password-change-page>
  <!-- Password Changed Modal -->
  <dialog if="{locale}" id="password-changed-modal" class="modal" aria-labelledby="password-changed-modal-title">
    <div class="modal-box max-w-md">
      <h3 id="password-changed-modal-title" class="font-bold text-lg mb-4 flex items-center gap-2">
        <i class="icon-metalark-check-circle text-success text-2xl"></i>
        {locale?.t('passwordchange_modal_title')}
      </h3>
      <div class="py-4">
        <p class="text-sm text-gray-600 mb-4">
          {locale?.t('passwordchange_modal_message')}
        </p>

        <div class="form-control">
          <label class="label cursor-pointer justify-start gap-3">
            <input
              id="passwordchange-revokeallsessions"
              type="checkbox"
              class="checkbox checkbox-primary"
              checked="{state.revokeAllSessions}"
              onchange="{(e) => { state.revokeAllSessions = e.target.checked; this.update(); }}"
            />
            <div class="flex-1">
              <span class="label-text font-semibold">{locale?.t('passwordchange_modal_revoke_label')}</span>
              <p class="text-xs text-gray-500 mt-1">
                {locale?.t('passwordchange_modal_revoke_description')}
              </p>
            </div>
          </label>
        </div>

        <div class="alert alert-info mt-4 text-xs">
          <i class="icon-metalark-info"></i>
          <span>{locale?.t('passwordchange_modal_revoke_recommended')}</span>
        </div>
      </div>
      <div class="modal-action">
        <button class="btn btn-ghost" onclick="{closePasswordChangedModal}">{locale?.t('passwordchange_modal_skip')}</button>
        <button class="btn btn-primary" onclick="{handlePasswordChangedConfirm}">
          {state.revokeAllSessions ? locale?.t('passwordchange_modal_confirm_revoke') : locale?.t('passwordchange_modal_continue')}
        </button>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button onclick="{closePasswordChangedModal}">close</button>
    </form>
  </dialog>

  <div if="{locale}" class="container">
    <div class="change-card">
      <div if={state.loading} class="loading-state">
        <div class="spinner"></div>
        <h2>{locale?.t('passwordchange_validating')}</h2>
        <p>{locale?.t('passwordchange_validating_message')}</p>
      </div>

      <div if={state.tokenValid && !state.success} class="password-form-state">
        <h2>{locale?.t('passwordchange_title')}</h2>
        <p class="form-description">{locale?.t('passwordchange_subtitle')}</p>
        
        <form onsubmit={handlePasswordSubmit} autocomplete="on">
          <input
            type="email"
            name="username"
            autocomplete="username"
            value={state.userEmail}
            style="display: none;"
            tabindex="-1"
            aria-hidden="true"
            tabindex="1"
          />
          
          <div class="form-group">
            <label for="current-password">{locale?.t('passwordchange_currentpassword')}</label>
            <div class="password-input-wrapper">
              <input
                type={state.showCurrentPassword ? 'text' : 'password'}
                id="current-password"
                name="current-password"
                autocomplete="current-password"
                value={state.currentPassword}
                oninput={handleCurrentPasswordInput}
                required
                placeholder="{locale?.t('passwordchange_currentpassword_placeholder')}"
              />
              <button
                type="button"
                class="password-toggle"
                onclick={toggleCurrentPasswordVisibility}
                aria-label={state.showCurrentPassword ? locale?.t('resetpassword_hidepassword') : locale?.t('resetpassword_showpassword')}
              >
                <i class="{state.showCurrentPassword ? 'icon-eye-blocked' : 'icon-eye'}"></i>
              </button>
            </div>
          </div>

          <div class="password-field-container">
            <div class="form-group password-input-column">
              <label for="new-password">{locale?.t('passwordchange_newpassword')}</label>
              <div class="password-input-wrapper">
                <input
                  type={state.showPassword ? 'text' : 'password'}
                  id="new-password"
                  name="new-password"
                  autocomplete="new-password"
                  value={state.password}
                  oninput={handlePasswordInput}
                  required
                  minlength="12"
                  placeholder="{locale?.t('passwordchange_newpassword_placeholder')}"
                  tabindex="2"
                />
                <button
                  type="button"
                  class="password-toggle"
                  onclick={togglePasswordVisibility}
                  aria-label={state.showPassword ? locale?.t('resetpassword_hidepassword') : locale?.t('resetpassword_showpassword')}
                >
                  <i class="{state.showPassword ? 'icon-eye-blocked' : 'icon-eye'}"></i>
                </button>
              </div>
            </div>

            <div class="password-requirements">
              <div class="requirements-title">{locale?.t('resetpassword_requirements')}</div>
              <ul class="requirements-list">
                <li class="{state.password.length >= 12 ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_length')} <span class="char-count">({state.password.length}/12)</span>
                </li>
                <li class="{/[A-Z]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_uppercase')}
                </li>
                <li class="{/[a-z]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_lowercase')}
                </li>
                <li class="{/[0-9]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_number')}
                </li>
                <li class="{/[@$!%*?&#^()_+\-=\[\]{}|;:,.<>~`]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_special')}
                </li>
              </ul>
            </div>
          </div>

          <div class="form-group">
            <label for="confirm-password">{locale?.t('passwordchange_confirmnewpassword')}</label>
            <div class="password-input-wrapper">
              <input
                type={state.showConfirmPassword ? 'text' : 'password'}
                id="confirm-password"
                name="confirm-password"
                autocomplete="new-password"
                value={state.confirmPassword}
                oninput={handleConfirmPasswordInput}
                required
                minlength="12"
                placeholder="{locale?.t('passwordchange_confirmnewpassword_placeholder')}"
                tabindex="3"
              />
              <button
                type="button"
                class="password-toggle"
                onclick={toggleConfirmPasswordVisibility}
                aria-label={state.showConfirmPassword ? locale?.t('resetpassword_hidepassword') : locale?.t('resetpassword_showpassword')}
              >
                <i class="{state.showConfirmPassword ? 'icon-eye-blocked' : 'icon-eye'}"></i>
              </button>
            </div>
          </div>

          <div if={state.passwordError} class="error-alert">{state.passwordError}</div>

          <button
            type="submit"
            class="btn btn-primary btn-block"
            disabled={state.changing}
          >
            {state.changing ? locale?.t('passwordchange_changing') : locale?.t('passwordchange_changebutton')}
          </button>
        </form>
      </div>

      <div if={state.success} class="success-state">
        <div class="success-icon">✓</div>
        <h2>{locale?.t('passwordchange_success_title')}</h2>
        <p>{state.message}</p>
        <p class="next-step">{locale?.t('passwordchange_success_nextstep')}</p>
        <a href="#/login" class="btn btn-primary">
          {locale?.t('passwordchange_success_gotologin')}
        </a>
      </div>

      <div if={state.error} class="error-state">
        <div class="error-icon">✗</div>
        <h2>{locale?.t('passwordchange_failed_title')}</h2>
        <p class="error-message">{state.message}</p>
        <div class="error-actions">
          <a href="#/login" class="btn btn-primary">{locale?.t('passwordchange_failed_returntologin')}</a>
        </div>
      </div>
    </div>
  </div>

  <style>
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      padding: 20px;
      border-radius: 20px;
    }

    .change-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      padding: 40px;
      max-width: 500px;
      width: 100%;
      text-align: center;
    }

    @media (min-width: 768px) {
      .change-card {
        max-width: 750px;
      }
    }

    .loading-state,
    .success-state,
    .error-state,
    .password-form-state {
      animation: fadeIn 0.3s ease-in;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .spinner {
      border: 4px solid #f3f3f3;
      border-top: 4px solid #667eea;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      animation: spin 1s linear infinite;
      margin: 0 auto 20px;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .success-icon,
    .error-icon {
      font-size: 64px;
      margin-bottom: 20px;
    }

    .success-icon {
      color: #10b981;
    }

    .error-icon {
      color: #ef4444;
    }

    h2 {
      color: #1f2937;
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 600;
    }

    p {
      color: #6b7280;
      line-height: 1.6;
      margin-bottom: 12px;
    }

    .next-step {
      color: #4b5563;
      font-weight: 500;
      margin-top: 20px;
      margin-bottom: 24px;
    }

    .error-message {
      color: #dc2626;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .form-description {
      color: #6b7280;
      margin-bottom: 24px;
    }

    .form-group {
      margin-bottom: 20px;
      text-align: left;
    }

    label {
      display: block;
      color: #374151;
      font-weight: 500;
      margin-bottom: 8px;
      font-size: 14px;
    }

    .password-input-wrapper {
      position: relative;
      display: flex;
      align-items: center;
    }

    .password-input-wrapper input {
      width: 100%;
      padding: 12px 48px 12px 16px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      font-size: 16px;
      transition: border-color 0.2s;
      box-sizing: border-box;
    }

    .password-input-wrapper input:focus {
      outline: none;
      border-color: #667eea;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

    .password-toggle {
      position: absolute;
      right: 12px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      opacity: 0.6;
      transition: opacity 0.2s;
    }

    .password-toggle:hover {
      opacity: 1;
    }

    .password-toggle:focus {
      outline: 2px solid #667eea;
      outline-offset: 2px;
      border-radius: 4px;
    }

    .password-field-container {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 20px;
    }

    .password-input-column {
      flex: 1;
      margin-bottom: 0;
    }

    .password-requirements {
      padding: 12px;
      background: #eff6ff;
      border: 1px solid #bfdbfe;
      border-radius: 8px;
      flex-shrink: 0;
      text-align: left;
    }

    .requirements-title {
      font-size: 12px;
      color: #1e40af;
      font-weight: 600;
      margin-bottom: 4px;
    }

    .requirements-list {
      list-style: disc;
      margin-left: 16px;
      padding-left: 4px;
      font-size: 12px;
      line-height: 1.6;
    }

    .requirements-list li {
      margin-bottom: 2px;
    }

    .requirement-pending {
      color: #1d4ed8;
    }

    .requirement-met {
      color: #15803d;
      font-weight: 600;
    }

    .char-count {
      font-family: monospace;
    }

    @media (min-width: 768px) {
      .password-field-container {
        flex-direction: row;
        align-items: flex-start;
        gap: 16px;
      }

      .password-input-column {
        flex: 1;
        max-width: 400px;
      }

      .password-requirements {
        width: 280px;
        margin-top: 32px;
      }
    }

    .error-alert {
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #dc2626;
      padding: 12px 16px;
      border-radius: 8px;
      margin-bottom: 16px;
      font-size: 14px;
    }

    .btn {
      padding: 8px 24px;
      border-radius: 8px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
      border: none;
      font-size: 16px;
      text-decoration: none;
      display: inline-block;
    }

    .btn-block {
      width: 100%;
      display: block;
    }

    .btn-primary {
      background: var(--color-primary);
      color: white;
    }

    .btn-primary:hover:not(:disabled) {
      background: var(--color-primary);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    .btn-primary:disabled {
      background: #9ca3af;
      cursor: not-allowed;
    }

    .error-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 24px;
    }

    @media (min-width: 640px) {
      .error-actions {
        flex-direction: row;
        justify-content: center;
      }
    }
  </style>

  <script>
    import { getApi } from '../services/service-loader'

    export default {
      includeTools: false,

      state: {
        loading: true,
        tokenValid: false,
        success: false,
        error: false,
        message: '',
        userEmail: '',
        currentPassword: '',
        password: '',
        confirmPassword: '',
        passwordError: '',
        changing: false,
        token: '',
        showCurrentPassword: false,
        showPassword: false,
        showConfirmPassword: false,
        revokeAllSessions: false
      },

      async onMounted() {
        const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
        const token = urlParams.get('token')

        if (!token) {
          this.update({
            loading: false,
            error: true,
            message: this.locale?.t('passwordchange_error_notoken')
          })
          return
        }

        this.update({ token: token })
        await this.validateToken(token)
      },

      async validateToken(token) {
        try {
          const api = await getApi()
          const response = await api.post('/auth/password/change/validate', {
            token: token
          })
          
          if (response.data.valid) {
            this.update({
              loading: false,
              tokenValid: true,
              error: false,
              userEmail: response.data.email || ''
            })
          } else {
            this.update({
              loading: false,
              tokenValid: false,
              error: true,
              message: response.data.message || this.locale?.t('passwordchange_error_invalidtoken')
            })
          }
        } catch (error) {
          console.error('Token validation error:', error)
          this.update({
            loading: false,
            tokenValid: false,
            error: true,
            message: error.response?.data?.message || this.locale?.t('passwordchange_error_invalidtoken')
          })
        }
      },

      handleCurrentPasswordInput(e) {
        this.update({ currentPassword: e.target.value, passwordError: '' })
      },

      handlePasswordInput(e) {
        this.update({ password: e.target.value, passwordError: '' })
      },

      handleConfirmPasswordInput(e) {
        this.update({ confirmPassword: e.target.value, passwordError: '' })
      },

      async handlePasswordSubmit(e) {
        e.preventDefault()

        const { currentPassword, password, confirmPassword, token } = this.state

        if (password !== confirmPassword) {
          this.update({ passwordError: this.locale?.t('passwordchange_error_nomatch') })
          return
        }

        if (!this.validatePasswordStrength(password)) {
          this.update({ passwordError: this.locale?.t('passwordchange_error_criteria') })
          return
        }

        this.update({ changing: true, passwordError: '' })

        try {
          const api = await getApi()
          const response = await api.post('/auth/password/change/complete', {
            token,
            currentPassword,
            newPassword: password,
            confirmPassword
          })

          if (response.data.success) {
            // Success! Show post-change security options modal
            this.update({
              changing: false,
              tokenValid: false
            })
            this.showPasswordChangedModal()
          } else {
            this.update({
              changing: false,
              passwordError: response.data.message || this.locale?.t('passwordchange_error_failed')
            })
          }
        } catch (error) {
          console.error('Password change error:', error)

          let errorMessage = this.locale?.t('passwordchange_error_tryagain')

          if (error.response?.status === 400) {
            errorMessage = error.response.data.message || this.locale?.t('passwordchange_error_invalidrequest')
          } else if (error.response?.status === 401) {
            errorMessage = this.locale?.t('passwordchange_error_unauthorized')
          }

          this.update({
            changing: false,
            passwordError: error.response?.data?.message || errorMessage
          })
        }
      },

      toggleCurrentPasswordVisibility() {
        this.update({ showCurrentPassword: !this.state.showCurrentPassword })
      },

      togglePasswordVisibility() {
        this.update({ showPassword: !this.state.showPassword })
      },

      toggleConfirmPasswordVisibility() {
        this.update({ showConfirmPassword: !this.state.showConfirmPassword })
      },

      validatePasswordStrength(password) {
        if (!password || password.length < 12) {
          return false
        }
        
        const hasUppercase = /[A-Z]/.test(password)
        const hasLowercase = /[a-z]/.test(password)
        const hasNumber = /[0-9]/.test(password)
        const hasSpecialChar = /[@$!%*?&#^()_+\-=\[\]{}|;:,.<>~`]/.test(password)
        
        return hasUppercase && hasLowercase && hasNumber && hasSpecialChar
      },
      
      showPasswordChangedModal() {
        document.getElementById('password-changed-modal').showModal()
      },
      
      closePasswordChangedModal() {
        document.getElementById('password-changed-modal').close()
        this.update({ revokeAllSessions: false })
        // Redirect after closing without action
        window.location.hash = '#settings?tab=security'
      },
      
      async handlePasswordChangedConfirm() {
        try {
          if (this.state.revokeAllSessions) {
            // Revoke all OTHER sessions (keep current session active)
            const response = await fetch('/api/v1/account/sessions/revoke-all', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                reason: 'Password changed via email - user requested to sign out everywhere else',
                keepCurrentSession: true
              })
            })
            
            if (!response.ok) {
              throw new Error('Failed to revoke sessions')
            }
            
            console.log('[PasswordChange] All other sessions revoked, current session kept active')
          }
          
          this.closePasswordChangedModal()
          
          // Show success state
          this.update({
            success: true,
            error: false,
            message: this.locale?.t('passwordchange_success_message') +
              (this.state.revokeAllSessions ? this.locale?.t('passwordchange_success_revoked') : '') + '.'
          })
        } catch (error) {
          console.error('Failed to revoke sessions:', error)
          this.closePasswordChangedModal()

          // Still show success but with warning
          this.update({
            success: true,
            error: false,
            message: this.locale?.t('passwordchange_success_revoke_failed')
          })
        }
      }
    }
  </script>
</password-change-page>